import {observeProp, store} from '..';
import {BgLayerSubGroup, LayerCollection, LayerGroup} from '../../model/layer/layer';
import {Language} from '../../constants/language';
import values from "ramda/es/values";

export function initCookieStore(): void {
    observeProp<LayerCollection>(store, ['map', 'layers']).subscribe(layerCollection => {
        const visibleBgLayers = values(layerCollection).filter(layer => layer.group === LayerGroup.BG && layer.options.visible)
            .map(layer => layer.subGroup);
        
        // Set() is used to remove duplicates
        const visibleBgLayersOrBasis = visibleBgLayers.length > 0 ?  [...new Set(visibleBgLayers)] : [BgLayerSubGroup.basis];

        const otherVisibleLayers = values(layerCollection)
            .filter(layer => layer.group !== LayerGroup.BG && layer.options.visible)
            .map(layer => layer.id)
        
        localStorage.setItem(
            'mapLayers',
            JSON.stringify( [...visibleBgLayersOrBasis, ...otherVisibleLayers])
        );
    });

    observeProp<Language>(store, ['settings', 'language']).subscribe(language => {
        localStorage.setItem('language', language);
    });
}
